define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../models/UserContext", "../../shared/dataLogs"], function (require, exports, $, ko, log, urls_1, UserContext, DataLogs) {
    "use strict";
    var BetterLogs = /** @class */ (function () {
        function BetterLogs() {
        }
        BetterLogs.prototype.init = function () {
            var self = this;
            $("#page-title").text("Logs");
            ko.applyBindings(self, document.getElementById("ko-main-content"));
            self.initLogs();
            $("#contextLoader").hide();
            $("#mainContext").show();
        };
        BetterLogs.prototype.initLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                self.dataLogs = new DataLogs("Login", null, true);
                self.dataLogs.initKendoLogs("divLogsTable", null, true);
            }
        };
        return BetterLogs;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Logs/Index")) {
            log.log("Initialize BetterLogs list");
            $(function () {
                (new BetterLogs()).init();
            });
        }
    }, 0);
    return BetterLogs;
});
//# sourceMappingURL=betterlogs.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/betterLogs/betterLogs.js
// module id = 247
// module chunks = 2